import * as React from 'react';
export const Component = React.forwardRef(({ children, renderAs, ...props }, ref) => React.createElement(renderAs, { ...props, ref }, children));
//# sourceMappingURL=GenericComponent.js.map